import React from 'react';
import { Form, Input, Button, Row, Col, Card, Spin, message } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import config from '../../config';
import styles from './styles.less';

const FormItem = Form.Item;

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailValid: false,
    };
  }

  getForgotPasswordForm() {
    const { getFieldDecorator } = this.props.form;
    return (<Form onSubmit={this.handleSubmit.bind(this)} className={styles.forgotPasswordForm}>
      <h2 className="header-text">
        <FormattedMessage id="Components.ForgotPassword.HeaderText" />
      </h2>
      <FormItem>
        {getFieldDecorator('email', {
          rules: [{
            type: 'email',
            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.ErrorValid' }),
          }, {
            required: true,
            message: this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Error' }),
          }],
        })(
          <Input maxLength={255} placeholder={this.props.intl.formatMessage({ id: 'Component.User.Administration.Users.Edit.Form.Email' })} />,
        )}
      </FormItem>
      <Button type="primary" htmlType="submit" className={styles.forgotPasswordFormBtn}>
        <FormattedMessage id="Components.ForgotPassword.NewPasswordRequest" />
      </Button>
      <Button type="primary" onClick={this.backToLogin.bind(this)} className={styles.forgotPasswordFormBtn}>
        <FormattedMessage id="Component.Categories.Edit.Cancel" />
      </Button>
    </Form>);
  }

  getThanks() {
    return (<Card className="text-center">
      <h2><FormattedMessage id="Components.ForgotPassword.ThankYou" /></h2>
      <Row>
        <Col span={24}>
          <p><FormattedMessage id="Components.ForgotPassword.FirstIndent" /></p>
          <p><FormattedMessage id="Components.ForgotPassword.SecondIndent" values={{ supportEmail: config['app.support_email'] }} /></p>
          <Button type="primary" onClick={this.backToLogin.bind(this)}>
            <FormattedMessage id="Components.ForgotPassword.BackToLogin" />
          </Button>
        </Col>
      </Row>
    </Card>);
  }

  backToLogin() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'LOGIN',
      },
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { email } = values;
        this.props.dispatch({
          type: 'app/forgotPassword',
          payload: { email },
        }).then(() => {
          this.setState({ isEmailValid: true });
        }).catch(() => {
          message.error(this.props.intl.formatMessage({ id: 'Common.InvalidTokenOrEmail' }));
        });
      }
    });
  }

  render() {
    return (
      <Spin spinning={!!this.props.loading.effects['app/forgotPassword']}>
        { this.state.isEmailValid ? this.getThanks() : this.getForgotPasswordForm() }
      </Spin>
    );
  }
}

export default withRouter(connect(
  ({ app, loading }) => ({ app, loading }),
)(Form.create()(injectIntl(ForgotPassword))));



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js